import { DEFAULT_ROOM } from "@yay/shared";
import { navigateToCreate, navigateToRoom } from "../config";
import { YayLogo } from "./YayLogo";

interface KickedScreenProps {
  /** Server's terminal error text (e.g. "alice kicked you"). */
  reason: string;
  /** Dismiss the screen and show the join form (rejoin is always allowed). */
  onRejoin: () => void;
}

/**
 * Full-viewport "you were kicked/banned" screen. Replacing the room the
 * instant a terminal moderation error arrives; the actions offered depend on
 * the severity: kicked → rejoin (allowed by design) or lobby; room-banned →
 * create your own room or lobby; banned from yay → nothing to do.
 */
export function KickedScreen({ reason, onRejoin }: KickedScreenProps) {
  const lower = reason.toLowerCase();
  const bannedGlobally = lower.includes("from yay");
  const banned = lower.includes("banned") || bannedGlobally;

  return (
    <div className="kicked-screen">
      <div className="kicked-card">
        <YayLogo variant="white" className="kicked-logo" />
        <h1 className="kicked-title">
          {bannedGlobally
            ? "You're banned from yay"
            : banned
              ? "You were banned"
              : "You were kicked"}
        </h1>
        {!bannedGlobally && <p className="kicked-reason">{reason}</p>}
        <div className="kicked-actions">
          {bannedGlobally ? (
            <p className="kicked-note">
              This restriction can't be lifted
              <br />
              from here.
            </p>
          ) : banned ? (
            <>
              <button
                type="button"
                className="btn-kicked-primary"
                onClick={() => navigateToCreate()}
              >
                Create your own room
              </button>
              <button
                type="button"
                className="btn-kicked-secondary"
                onClick={() => navigateToRoom(DEFAULT_ROOM)}
              >
                Back to the lobby
              </button>
            </>
          ) : (
            <>
              <button type="button" className="btn-kicked-primary" onClick={onRejoin}>
                Rejoin this room
              </button>
              <button
                type="button"
                className="btn-kicked-secondary"
                onClick={() => navigateToRoom(DEFAULT_ROOM)}
              >
                Back to the lobby
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
